module.exports = __webpack_public_path__ + "img/menu-close.52433462.svg";